// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/crm/leads/css/responsive.css
// module id = 4694
// module chunks = 0